import { render } from "./template.1376.vue?vue&type=template&id=5d2b3ce8"
import script from "./template.1376.vue?vue&type=script&lang=js"
export * from "./template.1376.vue?vue&type=script&lang=js"

import "./template.1376.vue?vue&type=style&index=0&id=5d2b3ce8&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__